import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import "../../css/Manage.css";
import "../../css/accomodation/ManageAccomodationSeeMore.css";
import AccomodationApi from "../../api/accomodationApi";
import { toast } from "react-toastify";
import AlertPopup from "../../components/AlertPopup";
import { Map, MapMarker } from "react-kakao-maps-sdk";

const ManageAccomodationSeeMore = () => {
  let navigate = useNavigate();
  let location = useLocation();

  //--삭제 state--//
  const [isOpen, setIsOpen] = useState(false);
  const [headerTitle, setHeaderTitle] = useState("삭제 하시겠습니까?");
  const [content, setContent] = useState(
    "삭제된 데이터는 복구가 불가능합니다."
  );
  const [alertValue, setAlertValue] = useState(false);
  const [cancelTitle, setCancelTitle] = useState("취소");
  const [confirmTitle, setConfirmTitle] = useState("삭제");
  //--삭제 state--//

  const [accomodationId, setAccomodationId] = useState(null);
  const [accomodationInfo, setAccomodationInfo] = useState({});

  useEffect(() => {
    try {
      if (location.state) {
        const { id } = location.state;
        setAccomodationId(location.state.id);
        getAccomodationInfo(id);
      }
    } catch (error) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  }, [location]);

  const getAccomodationInfo = async (id) => {
    try {
      const info = (await AccomodationApi.GetAccomodation(id)).data.data;
      setAccomodationInfo(info.content);
    } catch (error) {
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  //삭제 실행하는 곳
  const accomodationHandler = async () => {
    setIsOpen(true);
    setDeleteId(accomodationId);
  };

  const [deleteId, setDeleteId] = useState(-1);
  useEffect(() => {
    const del = async () => {
      try {
        if (deleteId <= 0) {
          return;
        }
        await AccomodationApi.Del(deleteId);
        toast("삭제되었습니다.");
        navigate("/admin/accomodation");
      } catch (error) {
        toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
      }
    };
    if (alertValue) {
      del();
    }
  }, [alertValue]);

  return (
    <div className="Manage-container">
      <section className="Manage-contents">
        <div className="go-back-container-accomodation-seemore">
          <div
            className="go-back"
            onClick={() => {
              navigate(-1);
            }}
          >
            <Link>
              <img src="\img\chevron-left.svg" />
              <span>뒤로가기</span>
            </Link>
          </div>
          <div>
            <Link onClick={accomodationHandler}>삭제</Link>
            <Link
              to={`/admin/accomodation/edit/${accomodationId}`}
              state={{ id: accomodationId }}
            >
              수정하기
            </Link>
          </div>
        </div>
        <div className="Manage-form manage-form-accomodation-see-more">
          <span>상세</span>
          <div className="Manage-form-view-details Manage-form-view-details-accomodation-seemore">
            <span>숙소명</span>
            <span>{accomodationInfo.name}</span>
          </div>
          <div className="Manage-form-view-details Manage-form-view-details-accomodation-seemore">
            <span>주소</span>
            <span>{accomodationInfo.address}</span>
          </div>
          {accomodationInfo.addressDetail && (
            <div className="Manage-form-view-details Manage-form-view-details-accomodation-seemore">
              <span>상세주소</span>
              <span>{accomodationInfo.addressDetail}</span>
            </div>
          )}
          {accomodationInfo.latitude && accomodationInfo.longitude && (
            <div className="Manage-form-view-details Manage-form-view-details-accomodation-seemore manage-flex-start">
              <span>좌표</span>
              <div>
                <Map
                  center={{
                    lat: parseFloat(accomodationInfo.latitude),
                    lng: parseFloat(accomodationInfo.longitude),
                  }}
                  style={{
                    width: "366px",
                    height: "366px",
                    borderRadius: "4px",
                  }}
                  level={2}
                  maxLevel={3}
                >
                  <MapMarker
                    position={{
                      lat: parseFloat(accomodationInfo.latitude),
                      lng: parseFloat(accomodationInfo.longitude),
                    }}
                  />
                </Map>
                <div className="map-position-info">
                  <div>위도 (y좌표) : {accomodationInfo.latitude}</div>
                  <div>경도 (x좌표) : {accomodationInfo.longitude}</div>
                </div>
              </div>
            </div>
          )}
          {accomodationInfo.description && (
            <div className="Manage-form-view-details Manage-form-view-details-accomodation-seemore manage-flex-start">
              <span>설명</span>
              <span>{accomodationInfo.description}</span>
            </div>
          )}
          {accomodationInfo.imageUrl && (
            <div className="Manage-form-view-details Manage-form-view-details-accomodation-seemore manage-flex-start">
              <span>이미지</span>
              <div className="Manage-form-view-details-img">
                <img src={accomodationInfo.imageUrl} alt="숙소 이미지" />
              </div>
            </div>
          )}
          {accomodationInfo.rooms?.length > 0 && (
            <div className="Manage-form-view-details Manage-form-view-details-accomodation-seemore manage-flex-start">
              <span>객실 목록</span>
              <div style={{ width: "100%" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ borderBottom: "1px solid #d7dbe0" }}>
                      <th style={{ padding: "10px", textAlign: "left" }}>
                        객실명
                      </th>
                      <th style={{ padding: "10px", textAlign: "left" }}>
                        가격
                      </th>
                      <th style={{ padding: "10px", textAlign: "left" }}>
                        이미지
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {accomodationInfo.rooms.map((room, index) => (
                      <tr
                        key={index}
                        style={{ borderBottom: "1px solid #eef2f3" }}
                      >
                        <td style={{ padding: "10px" }}>{room.name}</td>
                        <td style={{ padding: "10px" }}>{room.price}원</td>
                        <td style={{ padding: "10px" }}>
                          {room.imageUrl && (
                            <img
                              src={room.imageUrl}
                              alt={room.name}
                              style={{
                                width: "80px",
                                height: "80px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
        {/* 삭제 컴포넌트 */}
        <AlertPopup
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          headerTitle={headerTitle}
          content={content}
          setAlertValue={setAlertValue}
          cancelTitle={cancelTitle}
          confirmTitle={confirmTitle}
        />
      </section>
    </div>
  );
};

export default ManageAccomodationSeeMore;
